var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "10px",
    viewBox: "0 0 13 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06-Sourcy_mobile_Detail_v2",
    transform: "translate(-316.000000, -316.000000)",
    stroke: "#012169",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(30.000000, 255.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    points: "288 63 292.5 68 297 63"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowdown);
export default __webpack_public_path__ + "static/media/icon-arrowdown.081f7bdff047009a2ad3568b464622e6.svg";
export { ForwardRef as ReactComponent };